export const Template_BasicNLP = Object.freeze({ synonyms: [] });
//# sourceMappingURL=consts.js.map